import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  TimePicker,
} from "antd";

import React, { useState } from "react";

import FormAction from "../../../../components/common/FormAction";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";

import { activityStatus } from "../../../../utils/tenants";

import dayjs from "dayjs";

import "./AddActivity.css";

const AddActivityRightBar = [];

function AddActivity() {
  const [allDayChecked, setAllDayChecked] = useState(false);
  const format = "HH:MM";
  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <div className="add-activity">
            <PageHeading heading="Add New Activity" />
            <Form colon={false} layout="vertical">
              <Row>
                <Col span={24}>
                  <Form.Item label="Date" required>
                    <DatePicker />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item>
                    <Checkbox
                      checked={allDayChecked}
                      onChange={() => setAllDayChecked(!allDayChecked)}
                    >
                      All Day
                    </Checkbox>
                  </Form.Item>
                </Col>
                {allDayChecked ? null : (
                  <Col span={24} className="time-container">
                    <Form.Item label="Time">
                      <TimePicker
                        defaultValue={dayjs("12:08", format)}
                        format={format}
                      />
                    </Form.Item>
                    <Form.Item label="AM/PM">
                      <Select
                        options={[{ value: "AM" }, { value: "PM" }]}
                        defaultValue="AM"
                      />
                    </Form.Item>
                  </Col>
                )}
                <Col span={24}>
                  <Form.Item label="Description" required>
                    <Input placeholder="e.g. Annual inspection" />
                    <p className="silver-text">255 character max</p>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Label">
                    <Select
                      options={[{ value: "Section 8" }, { value: "Work Flow" }]}
                      placeholder="Type to search or add new"
                      allowClear
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Assign To">
                    <Select
                      options={[
                        { value: "Seerat" },
                        { value: "Kashif" },
                        { value: "Rimsha" },
                      ]}
                      placeholder="Start typing to search"
                      allowClear
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Status">
                    <Select options={activityStatus} defaultValue="Pending" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <FormAction />
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={AddActivityRightBar} />
      </div>
    </>
  );
}

export default AddActivity;
